import { BiogasShare } from '../../project/plant-specifications/biogas-share.model';

export class SliderData {
  public name: string;
  public type: string;
  public value: number | null;
  public uuid: string | null;

  constructor(biogasShare: BiogasShare) {
    this.name = biogasShare.name;
    this.type = biogasShare.name;
    this.value = biogasShare?.share?.value;
    this.uuid = biogasShare.uuid;
  }
}
